<template>
    <div class="modal fade" id="createSigningFromTaskModal" tabindex="-1" role="dialog" aria-labelledby="createSigningModalLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createSigningModalLabel">{{ $t('signing.new') }} {{ $tc('signing.pageTitle', 1) }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSubmit" v-show="!isSaving">
                    <div class="modal-body" v-if="showEditor">
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('signing.headers.title')}}</div>
                            <div class="w-100">
                                <input class="form-control" v-model="model.title" v-validate="'required'" :name="'title'+_uid" :data-vv-as="$t('signing.headers.title')" />
                                <span class="text-danger col-12" v-if="errors.has('title'+_uid)">{{ errors.first('title'+_uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('request_n')}}</div>
                            <div>
                                <textarea class="form-control w-100" :name="'textarea'+_uid" :data-vv-as="$t('request_n')" v-model="model.request" v-validate="'required'"></textarea>
                                <span class="text-danger col-12" v-if="errors.has('textarea'+_uid)">{{ errors.first('textarea'+_uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('signing.headers.signatories')}}</div>
                            <Signatories
                                v-model="model.signatories"
                                api-url="api/user/searchSignatories"
                                show-all-users-btn
                                :emptyMesssage="$t('signing.noSignatoriesMsg')"
                                :remove-add-btn="model.signatories && model.signatories.length >= 1">
                            </Signatories>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('signing.headers.deadline')}}</div>
                            <DatePicker
                                v-model="model.deadline"
                                :min="new Date()"
                                v-validate="'required'"
                                :data-vv-as="$t('signing.headers.deadline')"
                                :error="errors.first($t('signing.headers.deadline'))"
                                :fieldName="$t('signing.headers.deadline')"
                            ></DatePicker>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('signing.attachments')}}</div>
                            <div>
                                <div class="alert-warning">{{ $t('signing.allowedFilesTypesForSigning') }}</div>
                                <div class="mb-2" v-for="item in taskAttachments" :key="_uid+item.fileName">
                                    <div>{{ item.fileName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="!model || !model.signatories || !model.signatories.length">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Signatories from '@/components/coordinations/coordinators-list';
import DatePicker from '../datepicker/DateTimePicker';

import { Signing } from '@/models/models';
import signingService from '@/services/signing.service';
import { mapGetters } from 'vuex';

export default {
    components: {
        Signatories,
        DatePicker
    },
    props: {
        link: { type: String, required: false },
        title: { type: String, required: false },
        taskId: { type: Number, required: false },
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            model: new Signing(),
            isSaving: false,
            taskAttachments: [],
            showEditor: true
        };
    },
    computed: {
        ...mapGetters(['signingAllowFileTypes'])
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            if (this.model.signatories.length) {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.save();
                    } else {
                        console.log('Form not valid');
                    }
                });
            }
        },
        save() {
            this.isSaving = true;
            let data = new FormData();
            data.append('deadline', this.model.deadline ? this.model.deadline.toJSON() : '');
            data.append('request', this.model.request || '');
            data.append('title', this.model.title || '');

            // signatories
            for (let index = 0; index < this.model.signatories.length; index++) {
                const element = this.model.signatories[index];

                data.append(`signatories[${index}].userId`, element.userId);
                data.append(`signatories[${index}].sort`, element.sort || index);
            }

            // files
            if (this.model.attachments.length) {
                for (let index = 0; index < this.model.attachments.length; index++) {
                    const attachment = this.model.attachments[index];
                    data.append(`files`, attachment.content);
                }
            }

            signingService
                .createFromTask(data, this.taskId)
                .then(result => {
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('createSuccess'),
                        text: ''
                    });
                    this.$emit('updated', this.model);
                    this.hide();
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    });
                })
                .then(() => (this.isSaving = false));
        },
        onClose() {
            this.$emit('update:show', false);
            this.$emit('onClose');
            this.isSaving = false;
            this.model = new Signing();
            this.showEditor = false;
            this.$validator.reset();
        },
        hide() {
            $(this.$el).modal('hide');
        },
        onRemoveFile(_id) {
            this.model.attachments = this.model.attachments.filter(x => x._id !== _id);
        },
        mountModel() {
            this.loadAttachments();
            $('#task-type-choice').bootstrapMaterialDesign();
        },
        async loadAttachments() {
            const result = await this.$http.get(`api/Tasks/GetTaskAttachments/${this.taskId}`);
            if (result.data && Array.isArray(result.data)) {
                const signingAllowFileTypes = this.signingAllowFileTypes;
                this.taskAttachments = result.data.filter(x => x.type && signingAllowFileTypes.includes(x.type));
            } else {
                this.taskAttachments = [];
            }
        }
    },
    mounted() {
        // add modal close listener
        $(this.$el).on('hidden.bs.modal', this.onClose);
        $(this.$el).on('shown.bs.modal', this.mountModel);
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off('hidden.bs.modal');
    },
    watch: {
        show: function (val) {
            if (val) {
                this.showEditor = true;
            }
            this.model = new Signing();
        }
    }
};
</script>

<style lang="scss" scoped>
.radio-message {
    padding: 3px 3px 3px 5px;
    border-left: 3px solid #03a9f4;
    box-shadow: 1px 1px 1px 1px lightgrey;
}

div.radio label {
    color: inherit;
    cursor: pointer;
}

.bmd-form-group {
    padding-top: 1rem !important;
}
</style>
